import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BsDatepickerModule } from 'ngx-bootstrap';
import {UrlConstants} from '../../../shared/url.constant';
import {FormBuilder} from '@angular/forms';
import {AdminService} from '../../../shared/admin.services';
import {Router} from '@angular/router';
import {CommonUtil} from '../../../utils/common.util';

@Component({
  selector: 'history-list',
  templateUrl: './history-list.component.html',
  styleUrls: ['./history-list.component.scss']
})
export class HistoryListComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  public todayDate = CommonUtil.formatDate(new Date());

  displayMessage: string;
  showAlertSuccess = false;
  showAlertFailure = false;
  showloader = false;
  transaction_id = '';
  submitted = false;
  feeDetails = [];

  @Input() paymentHistory;
  @Input() unpaid;
  @Input() searchParams;
  @Input() currentMenu

  @Output() onSort: EventEmitter<any> = new EventEmitter<any>();

  @Output() onSearchClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() currentMenuPage

  paymentData;
  cancellation_remarks: string;
  KEY_SORT_PAYMENT_DATE = '&sort_by=payment_date';
  KEY_SORT_RECEIPT_ID = '&sort_by=receipt_id';
  KEY_SORT_ASC = '&sort_order=asc';
  KEY_SORT_DESC = '&sort_order=desc';


  // @Output() onSearchReturned: EventEmitter<any> = new EventEmitter<any>();

  constructor(public fb: FormBuilder, private adminService: AdminService, private router: Router) {
  }

  viewHistory(data) {

    this.paymentData = null;
    this.showloader = true;
    const pathParam = data.id;
    const url = UrlConstants.getTransactionById + '/' + pathParam;
    this.adminService.get({url: url, params: ''}).then(res => {
      if (res.success) {
        this.showloader = false;
        this.paymentData = res.data.content;
        this.dismissAlertMessage();
      } else {
        this.showloader = false;
        // this.displayMessage = res.message;
        // this.showAlertMessage('danger');
      }

      (<any>$('#payment-history-modal')).modal({ backdrop: 'static', keyboard: false });
      (<any>$('#payment-history-modal')).modal('show');

    }).catch((error) => {
      this.paymentData = null;
      this.showloader = false;
      this.displayMessage = error.message;
      this.dismissAlertMessage();
      (error.status === 400) ? this.showAlertMessage('warning') : this.showAlertMessage('danger');
      // console.log(' ## ' + error.text);
    });
  }


  showAlertMessage(type: string): void {
    window.scrollTo(0, 0);
    switch (type) {
      case 'success':
        this.showAlertSuccess = true;
        break;
      case 'warning':
        this.showAlertFailure = true;
        break;
      case 'danger':
        this.showAlertFailure = true;
        break;
      default:
        break;
    }
  }

  dismissAlertMessage(): void {
    this.showAlertSuccess = false;
    this.showAlertFailure = false;
  }

  sortPaymentDateAsc() {
    if (this.searchParams.includes(this.KEY_SORT_PAYMENT_DATE)) {
      this.searchParams = this.searchParams.replace(/&sort_order=desc/g, this.KEY_SORT_ASC);
    } else if (this.searchParams.includes(this.KEY_SORT_RECEIPT_ID)) {
      this.searchParams = this.searchParams.replace(/&sort_order=desc/g, this.KEY_SORT_ASC);
      this.searchParams.replace(/&sort_by=receipt_id/g, this.KEY_SORT_PAYMENT_DATE);
    } else {
      this.searchParams = this.searchParams + this.KEY_SORT_PAYMENT_DATE + this.KEY_SORT_ASC;
    }
    const searchParam = this.searchParams;
    const data = {
      queryParams : searchParam,
      displayMessage : ''
    };
    setTimeout(() => { this.onSort.emit(data); }, 100);
  }

  sortPaymentDateDesc() {
    if (this.searchParams.includes(this.KEY_SORT_PAYMENT_DATE)) {
      this.searchParams = this.searchParams.replace(/&sort_order=asc/g, this.KEY_SORT_DESC);
    } else if (this.searchParams.includes(this.KEY_SORT_RECEIPT_ID)) {
      this.searchParams = this.searchParams.replace(/&sort_order=asc/g, this.KEY_SORT_DESC);
      this.searchParams = this.searchParams.replace(/&sort_by=receipt_id/g, this.KEY_SORT_PAYMENT_DATE);
    } else {
      this.searchParams = this.searchParams + this.KEY_SORT_PAYMENT_DATE + this.KEY_SORT_DESC;
    }
    const searchParam = this.searchParams;
    const data = {
      queryParams : searchParam,
      displayMessage : ''
    };
    setTimeout(() => { this.onSort.emit(data); }, 100);
  }

  sortReceiptIdAsc() {
    if (this.searchParams.includes(this.KEY_SORT_RECEIPT_ID)) {
      this.searchParams = this.searchParams.replace(/&sort_order=desc/g, this.KEY_SORT_ASC);
    } else if (this.searchParams.includes(this.KEY_SORT_PAYMENT_DATE)) {
      this.searchParams = this.searchParams.replace(/&sort_order=desc/g, this.KEY_SORT_ASC);
      this.searchParams = this.searchParams.replace(/&sort_by=payment_date/g, this.KEY_SORT_RECEIPT_ID);
    } else {
      this.searchParams = this.searchParams = this.searchParams + this.KEY_SORT_RECEIPT_ID + this.KEY_SORT_ASC;
    }
    const searchParam = this.searchParams;
    const data = {
      queryParams : searchParam,
      displayMessage : ''
    };
    setTimeout(() => { this.onSort.emit(data); }, 100);
  }

  sortReceiptIdDesc() {
    if (this.searchParams.includes(this.KEY_SORT_RECEIPT_ID)) {
      this.searchParams = this.searchParams.replace(/&sort_order=asc/g, this.KEY_SORT_DESC);
    } else if (this.searchParams.includes(this.KEY_SORT_PAYMENT_DATE)) {
      this.searchParams = this.searchParams.replace(/&sort_order=asc/g, this.KEY_SORT_DESC);
      this.searchParams = this.searchParams.replace(/&sort_by=payment_date/g, this.KEY_SORT_RECEIPT_ID);
    } else {
      this.searchParams = this.searchParams + this.KEY_SORT_RECEIPT_ID + this.KEY_SORT_DESC;
    }
    const searchParam = this.searchParams;
    const data = {
      queryParams : searchParam,
      displayMessage : ''
    };
    setTimeout(() => { this.onSort.emit(data); }, 100);
  }

  openDeleteModal(id) {
    this.submitted = true;
    this.transaction_id = id;
    this.cancellation_remarks = ""
    this.feeDetails = this.paymentHistory.filter(item => {
      return item.master_transaction_id === id;
    });

    (<any>$('#payment-cancel-reason')).modal({ backdrop: 'static', keyboard: false });
    (<any>$('#payment-cancel-reason')).modal('show');
  }

  submitCancelFee() {
    this.showloader = true;
    this.paymentData = null;
    (<any>$('#payment-cancel-reason')).modal('hide');
    const url = UrlConstants.cancelFee + '/' + this.transaction_id;
    let paramObj ={
      cancellation_remarks: this.cancellation_remarks
    }
    const searchParam = this.searchParams;

    let data = {
    };

    this.adminService.put({url: url, params: paramObj}).then(res => {
      if (res.success) {
        data = {

      queryParams : searchParam,
      displayMessage : res.message,
      success: true,
      cancelMessage: res.message,
      cancelSuccess: true

        }
        this.showloader = true
        setTimeout(() => {
          this.showloader = false
          this.onSearchClicked.emit(data); }, 1500);

        this.submitted = false
        this.dismissAlertMessage();
      } else {
        data = {

          queryParams : searchParam,
          displayMessage : res.message,
          success: false,
        cancelMessage: res.message,
        cancelSuccess: false


            }
        this.showloader = false;
      }

    }).catch((error) => {
      this.paymentData = null;
      this.showloader = false;
      this.displayMessage = error.message;
      this.dismissAlertMessage();
      (error.status === 400) ? this.showAlertMessage('warning') : this.showAlertMessage('danger');
    });
  }

  refreshPage() {
    window.location.reload();
   }

   dateformat(data) {
     return data.split(" ", [1])
   }

  closeSubmitModal(){
    (<any>$('#payment-cancel-reason')).modal('hide');
  }

  ngOnInit() {
  }

}
